<template>
    <div>
        <v-alert
            v-for="(item, index) in announcements"
                :key="index"
                :value="true"
                :color="getColor(item)"
                :icon="item.icon"
                outline
                class="rounded-4 mt-2"
        >
             <v-chip
                v-if="item.recipient"
                small
                outlined
                :class="isMobile?'recipient-chip-mobile':'recipient-chip'"
                dark
            >
                To: {{ item.recipient }}
            </v-chip>
  
            <div @click="showDetails(item.detailsLink)" :class="item.detailsLink?'header-clickable':''" :title="item.detailsLink?'Click to view details':''">
                <strong>{{ item.typeName }}</strong>
                <span v-if="item.detailsLink">&nbsp;<v-icon small>open_in_new</v-icon></span>
            </div>
            <div v-if="item.displayDuration" class="details-section">
                Schedule: {{ formatSchedule(item) }}
            </div>
            <div class="details-section">{{ item.details }}</div>
        </v-alert>
     </div>
</template>

<script>

import companyAnnouncementsApi from '@/api/company-announcements'

export default {
    data() {
        return {
            announcements: [],
            error: false,
            errorMessage: null
        }
    },
    methods: {
        showDetails(link) {
            if (link) window.open(link)
        },
        async getNowShowing() {
            try {
                // Load cached data first for fast UI
                const cachedData = localStorage.getItem('companyNotifications')
                if (cachedData) {
                    this.announcements = JSON.parse(cachedData)
                }

                // Fetch latest data
                const response = await companyAnnouncementsApi.getNowShowing()
                if (response && response.status === 200) {
                    this.announcements = response.data.items
                    localStorage.setItem('companyNotifications', JSON.stringify(this.announcements))
                }
            } catch (error) {
                this.error = true
                this.errorMessage = error.message || error
            }
        },
        formatSchedule(data) {
            const start = this.$moment(data.effectiveDate)
            const end = this.$moment(data.expirationDate)
            const today = this.$moment()

            const startDateLabel = today.isSame(start, 'day')
                ? `Today (${start.format('ddd')})`
                : start.format('MMM D (ddd)')

            const endDateLabel = today.isSame(end, 'day')
                ? `Today (${end.format('ddd')})`
                : end.format('MMM D (ddd)')

            // If start and end are the same day
            if (start.isSame(end, 'day')) {
                return `${startDateLabel} from ${start.format('h:mm A')} to ${end.format('h:mm A')}`
            }

            // If start and end are different days
            return `${startDateLabel} ${start.format('h:mm A')} to ${endDateLabel} ${end.format('h:mm A')}`
        },
        getColor(item) {
            // If API gives hex code, use it; otherwise fallback to Vuetify color name
            if (item.backgroundColor && item.backgroundColor.startsWith('#')) {
                return item.backgroundColor
            }
            return item.backgroundColor || 'primary'
        }
    },
    created() {
        this.getNowShowing()
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
    },
}
</script>
<style scoped>
.header-clickable {
    text-decoration: underline;
    cursor: pointer;
}
.recipient-chip {
    position: absolute;
    top: 8px;
    right: 5px;
    font-size: 10px;
}
.recipient-chip-mobile {
    margin-left:0px;
    font-size: 10px;
}
.details-section {
    color: #3b3b3b;
}
</style>
